import React from 'react';

const SvgIcHome = props => (
  <svg
    id="icon__pin_1"
    width={props.size || 25}
    height={props.size || 25}
    viewBox="0 0 19 19.119"
    xmlSpace="preserve"
    fill="#104eb2"
    {...props}
  >
    <path d="M18.895 8.724L9.499 0 .104 8.724a.328.328 0 00.446.48l1.087-1.009v10.924h15.724V8.194L18.448 9.2a.328.328 0 00.446-.48zm-11.361 9.74v-5.241a1.966 1.966 0 013.931 0v5.241zm9.172 0h-4.589v-5.241a2.621 2.621 0 00-5.241 0v5.241H2.293V7.586L9.499.894l7.207 6.692z" />
  </svg>
);

export default SvgIcHome;
